<template>
    <div class="col-12 pt-3">
        <button v-on:click="scrollToSection(section.sectionFrontId)" class="menuSectionBtn">{{ section.section }}</button>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'MenuSections',
    props: ['section'],
    methods: {
        scrollToSection: function (id) {
            var section = $('#'+id);
            $('html, body').animate({
                scrollTop: section.offset().top
            }, 500);
        }
    }
}
</script>


<style>
 .menuSectionBtn {
    font-size: 17px;
    color: #d3a971;
    line-height: 1;
    text-decoration: underline;
    border: none;
    padding: 0;
}
</style>